<div class="dialog-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="grid-column d-grid gap-14">
        <div class="form-group">
            <app-input context="Normal" class="form-item" label="First name" placeholder="Enter First name" type="text"
                [control]="form.get('firstName')" formControlName="firstName"
                [customErrorMessages]="customErrorMessages.firstName">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Last name" placeholder="Enter Last name" type="text"
                [control]="form.get('lastName')" formControlName="lastName"
                [customErrorMessages]="customErrorMessages.lastName">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Primary Email" placeholder="Enter Primary Email"
                type="text" [control]="form.get('primaryEmail')" formControlName="primaryEmail"
                [customErrorMessages]="customErrorMessages.primaryEmail">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Secondary Email" placeholder="Enter Secondary Email"
                type="text" [control]="form.get('secondaryEmail')" formControlName="secondaryEmail"
                [customErrorMessages]="customErrorMessages.secondaryEmail">
            </app-input>
        </div>

        <div class="form-group">
            <app-input context="Normal" class="form-item" label="Phone number" placeholder="Enter Phone number"
                type="number" [control]="form.get('mobileNumber')" formControlName="mobileNumber"
                [customErrorMessages]="customErrorMessages.mobileNumber">
            </app-input>
        </div>



        <button type="submit" style="display: none;" #submitBtn></button>
    </form>
</div>